// import { CToast, CToastBody, CToaster, CToastHeader } from "@coreui/react";

import React from "react";
import { CToaster, CToast, CToastHeader, CToastBody } from "@coreui/react";

const ToastMessage = ({ toasts, setToasts }) => {
  // Function to remove a toast by id
  const removeToast = (id) => {
    setToasts(toasts.filter((toast) => toast.id !== id));
  };
  const setcolor = (type) => {
    return type === "error" ? "danger" : type;
  };
  return (
    toasts &&
    toasts.length > 0 && (
      <>
        <CToaster key="ctoaster" position="top-right">
          {/* toasters[toasterKey].map((toast, key)=>{ */}
          {toasts.map((toast, key) =>
            toast.autohide === 0 ? (
              <>
                {" "}
                <CToast
                  key={"toast" + key}
                  show={true}
                  //autohide={toast.autohide || 3000}
                  fade={true}
                  color={setcolor(toast.type)}
                  onDismiss={() => removeToast(toast.id)}
                >
                  <CToastHeader closeButton={toast.closeButton}>
                    {toast.type.charAt(0).toUpperCase() + toast.type.slice(1)}
                  </CToastHeader>
                  <CToastBody>{toast.message}</CToastBody>
                </CToast>
              </>
            ) : (
              <CToast
                key={"toast" + key}
                show={true}
                autohide={toast.autohide || 3000}
                fade={true}
                color={setcolor(toast.type)}
                onDismiss={() => removeToast(toast.id)}
              >
                <CToastHeader closeButton={toast.closeButton}>
                  {toast.type.charAt(0).toUpperCase() + toast.type.slice(1)}
                </CToastHeader>
                <CToastBody>{toast.message}</CToastBody>
              </CToast>
            )
          )}
        </CToaster>
      </>
    )
  );
};

export default ToastMessage;
// <CToast
//   key={toast.id}
//   //show={params.ShowHideAlert.ShowHide}
//   autohide={3000}
//   fade={true}
//   //visible={true}
//   color={toast.type}
//   //onDismiss={() => removeToast(toast.id)}
// >
//   <CToastHeader closeButton>
//     {toast.type.charAt(0).toUpperCase() + toast.type.slice(1)}
//   </CToastHeader>
//   <CToastBody>{toast.message}</CToastBody>
// </CToast>

//const ToastMessage = ({ toasts, setToasts }) => {
//let getAlertType = params.ShowHideAlert.AlertType;
//   if (getAlertType !== undefined && getAlertType.toString().length > 0) {
//     let alertClass = "";
//     alertClass = RetunClassName(getAlertType.toLowerCase());
//     if (alertClass !== "") {
//       SetClass(
//         "me-auto text-" + alertClass.toLowerCase(),
//         "text-" + alertClass.toLowerCase(),
//         alertClass.toLowerCase()
//       );
//     } else {
//       SetClass("me-auto", "", "");
//     }
//   } else {
//     params.ShowHideAlert.AlertType = "Success";
//     SetClass("me-auto", "", "");
//   }

//   function RetunClassName(getAlertType) {
//     switch (getAlertType) {
//       case "sucess":
//         return AlertClass.SUCESS;
//       case "error":
//         return AlertClass.ERROR;
//       case "warning":
//         return AlertClass.WARNING;
//       case "info":
//         return AlertClass.INFO;
//       case "primary":
//         return AlertClass.PRIMARY;
//       case "secondary":
//         return AlertClass.SECONDARY;
//       default:
//         return "";
//     }
//   }

//   function SetClass(titleTextClass, textClass, bgColor) {
//     params.ShowHideAlert.TitleTextClass = titleTextClass;
//     params.ShowHideAlert.TextClass = textClass;
//     params.ShowHideAlert.BgColor = bgColor;
//   }
//   const [toasts, setToasts] = useState([
//     {
//       position: "top-right",
//       autohide: 3000,
//       closeButton: true,
//       fade: true,
//       title: "Success",
//     },
//   ]);

//   //   const addToast = () => {
//   //     setToasts([
//   //       ...toasts,
//   //       { position: "top-right", autohide: 3000, closeButton: true, fade: true },
//   //     ]);
//   //   };
//   const toasters = (() => {
//     return toasts.reduce((toasters, toast) => {
//       toasters[toast.position] = toasters[toast.position] || [];
//       toasters[toast.position].push(toast);
//       return toasters;
//     }, {});
//   })();

//   return (
//     <>
//       {Object.keys(toasters).map((toasterKey) => (
//         <CToaster position={toasterKey} key={"toaster" + toasterKey}>
//           {toasters[toasterKey].map((toast, key) => {
//             return (
//               <CToast
//                 key={"toast" + key}
//                 show={params.ShowHideAlert.ShowHide}
//                 autohide={toast.autohide || 3000}
//                 fade={true}
//               >
//                 <CToastHeader
//                   closeButton={toast.closeButton}
//                   onClose={() =>
//                     params.SetShowHideAlert((prevState) => ({
//                       ...prevState,
//                       ShowHide: false,
//                       AlertResponse: "Invalid Login.",
//                     }))
//                   }
//                 >
//                   {params.ShowHideAlert.AlertType}
//                 </CToastHeader>
//                 <CToastBody>{params.ShowHideAlert.AlertMessage}</CToastBody>
//               </CToast>
//               //   <CToast
//               //     key={"toast2"}
//               //     onClose={() =>
//               //       params.SetShowHideAlert((prevState) => ({
//               //         ...prevState,
//               //         ShowHide: false,
//               //         AlertResponse: "Invalid Login.",
//               //       }))
//               //     }
//               //     show={params.ShowHideAlert.ShowHide}
//               //     autohide={3000}
//               //     fade={true}
//               //   >
//               //     <CToastHeader closeButton={true}>
//               //       {params.ShowHideAlert.AlertType}
//               //     </CToastHeader>
//               //     <CToastBody>{params.ShowHideAlert.AlertMessage}</CToastBody>
//               //   </CToast>
//             );
//           })}
//         </CToaster>
//       ))}
//       {/* {params.ShowHideAlert.IsAutoHide === true && (
//         <ToastContainer position="top-center">

//           <Toast
//             onClose={() =>
//               params.SetShowHideAlert((prevState) => ({
//                 ...prevState,
//                 ShowHide: false,
//                 AlertResponse: "Invalid Login.",
//               }))
//             }
//             show={params.ShowHideAlert.ShowHide}
//             delay={3000}
//             autohide
//           >
//             <Toast.Header>
//               <strong className={params.ShowHideAlert.TitleTextClass}>
//                 {params.ShowHideAlert.AlertType}
//               </strong>

//             </Toast.Header>
//             <Toast.Body className={params.ShowHideAlert.TextClass}>
//               {params.ShowHideAlert.AlertMessage}
//             </Toast.Body>
//           </Toast>
//         </ToastContainer>
//       )}
//       {params.ShowHideAlert.IsAutoHide === false && (
//         <ToastContainer position="top-center">
//           <Toast
//             onClose={() =>
//               params.SetShowHideAlert((prevState) => ({
//                 ...prevState,
//                 ShowHide: false,
//                 AlertResponse: "Invalid Login.",
//               }))
//             }
//             show={params.ShowHideAlert.ShowHide}
//           >
//             <Toast.Header>

//               <strong className={params.ShowHideAlert.TitleTextClass}>
//                 {params.ShowHideAlert.AlertType}
//               </strong>
//             </Toast.Header>
//             <Toast.Body className={params.ShowHideAlert.TextClass}>
//               {params.ShowHideAlert.AlertMessage}
//             </Toast.Body>
//           </Toast>
//         </ToastContainer>
//       )} */}
//     </>
//   );
// };

// export default ToastMessage;
